'use strict'
var twentyninetimes = twentyninetimes || {}

twentyninetimes.rankMathFaq =
  twentyninetimes.rankMathFaq ||
  (function () {
    function init() {
      const rank_math_faqs = document.querySelectorAll('.rank-math-list-item')
      if (rank_math_faqs) {
        rankMathFaqFunction(rank_math_faqs)
        replaceCallUsButton()
      }
    }

    function replaceCallUsButton() {
      const callUsButtons = document.querySelectorAll('.call-us-button')
      if (callUsButtons.length > 0) {
        for (let i = 0; i < callUsButtons.length; i++) {
          const theButton = callUsButtons[i]
          const theButtonWrapper = callUsButtons[i].parentNode
          let newButton = document.createElement('a')
          let newButtonWrapper = document.createElement('span')

          newButton.setAttribute(
            'rel',
            '/formbuilder/ContactForm.aspx?fid=32792f90-ac6a-46ad-927c-8e09e009d082'
          )
          newButton.setAttribute('class', 'Button btnCall GotoURL btn')

          newButton.innerHTML = 'ring til os'
          newButtonWrapper.setAttribute(
            'class',
            'formbtn formbtn_btnCallScheduled'
          )

          newButtonWrapper.appendChild(newButton)
          theButtonWrapper.parentNode.replaceChild(
            newButtonWrapper,
            theButtonWrapper
          )

          //   theButton.parentNode.replaceChild(newButton, theButton);

          // console.log(theButtonWrapper, newButtonWrapper);
        }
      }
    }

    function rankMathFaqFunction(faqs) {
      faqs.forEach((faq) => {
        var id = faq.getAttribute('id').replace('faq-question-', ''),
          question = faq.querySelector('.rank-math-question'),
          answer = faq.querySelector('.rank-math-answer'),
          content = answer.innerHTML

        question.setAttribute('id', 'faq-toggle-' + id)
        question.setAttribute('role', 'button')
        question.setAttribute('aria-expanded', 'false')
        question.setAttribute('aria-controls', 'faq-content-' + id)

        answer.setAttribute('id', 'faq-content-' + id)
        answer.setAttribute('aria-labelledby', 'faq-toggle-' + id)

        answer.innerHTML =
          '<div class="rank-math-answer__inner wysiwyg">' + content + '</div>'
      })
    }

    return {
      init: init,
    }
  })()
